import { ModuleVables } from 'utils/vable';
import useStyles from './styles';

import {
  Check as CheckIcon,
  Create as CreateIcon,
  PriorityHigh as PriorityHighIcon,
  Replay as ReplayIcon,
} from '@mui/icons-material';
import {
  Box,
  CircularProgress as MaterialCircularProgress,
  Tooltip,
  Typography,
} from '@mui/material';

const CircularProgress = (props) => {
  let { value, loading, symbol, errorMessage, status, ...remainingProps } = props;

  const { classes } = useStyles({ value, loading, status });
  const { SimulationStatuses: statuses } = ModuleVables;

  let v = value;
  let s;
  if (status === statuses.SUCCEEDED.value) {
    s = <CheckIcon />;
  } else if (
    status === statuses.FAILED.value ||
    status === statuses.MD_FAILURE.value ||
    status === statuses.PARTIAL_RESULTS.value ||
    status === statuses.ERROR.value
  ) {
    s = <PriorityHighIcon />;
    v = 100;
  } else if (status === statuses.OUTDATED.value || status === statuses.TERMINATED.value) {
    s = <ReplayIcon />;
    v = 100;
  } else if (status === statuses.INCOMPLETE.value || status === statuses.READY.value) {
    s = <CreateIcon />;
    v = 100;
  } else {
    s = `${Math.round(value)}%`;
  }

  return (
    <Tooltip
      classes={{
        tooltip: classes.customTooltip,
        arrow: classes.customArrow,
      }}
      title=""
      arrow
    >
      <Box component="div" position="relative" display="inline-flex" className={classes.root}>
        <MaterialCircularProgress
          variant={!loading ? 'determinate' : 'indeterminate'}
          className={classes.progress}
          value={v}
          {...remainingProps}
        />
        <Box
          component="div"
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {!loading && (
            <Typography variant="caption" component="div" className={classes.value}>
              {symbol ? symbol : s}
            </Typography>
          )}
        </Box>
      </Box>
    </Tooltip>
  );
};

export default CircularProgress;
